import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { SUCCESS_TIMER_THEME } from '../constants/chatBannerThemes';

export const types = {
  SHOW_CHAT_ALERT_BANNER: 'SHOW_CHAT_ALERT_BANNER',
  HIDE_CHAT_ALERT_BANNER: 'HIDE_CHAT_ALERT_BANNER',
};

export const { showChatAlertBanner, hideChatAlertBanner } = createActions(
  {
    [types.SHOW_CHAT_ALERT_BANNER]: (theme) => ({
      theme,
    }),
  },
  types.HIDE_CHAT_ALERT_BANNER
);

const INIT_STATE = {
  showAlertBanner: false,
  theme: SUCCESS_TIMER_THEME,
};

const reducer = handleActions(
  {
    [types.SHOW_CHAT_ALERT_BANNER]: (state, action) => ({
      showAlertBanner: true,
      theme: action.payload.theme,
    }),
    [types.HIDE_CHAT_ALERT_BANNER]: () => ({
      ...INIT_STATE,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getChatAlertBanner = (state) => state.chat.chatAlertBanner;
export const getChatAlertBannerStatus = createSelector(
  getChatAlertBanner,
  (chatAlertBanner) => chatAlertBanner.showAlertBanner
);
export const getChatAlertBannerTheme = createSelector(
  getChatAlertBanner,
  (chatAlertBanner) => chatAlertBanner.theme
);



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/chatAlertBanner.js